import { useSelector } from "react-redux";

function useVariaveisAmbiente() {
  return useSelector(state => state.variaveisAmbiente);
}

export default useVariaveisAmbiente;
